(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kilde-angles"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-k-ang]').forEach(function(root){
    var tabs=root.querySelectorAll('.k-ang__tab'),ps=root.querySelectorAll('.k-ang__p');
    tabs.forEach(function(t){t.addEventListener('click',function(){
      var i=t.getAttribute('data-i');
      tabs.forEach(function(x){var on=x===t;x.classList.toggle('is-on',on);x.setAttribute('aria-selected',on?'true':'false')});
      ps.forEach(function(p){p.classList.toggle('is-on',p.getAttribute('data-i')===i)});
      var bar=t.parentNode;bar.scrollTo({left:t.offsetLeft-bar.offsetLeft-16,behavior:'smooth'});
    })});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kilde-depth"] && !Shopify.designMode) return;
  try {
    
(function(){
  var secs=[].slice.call(document.querySelectorAll('[data-k-depth]'));if(!secs.length)return;
  function upd(){secs.forEach(function(s){
    var t=s.querySelector('.k-depth__track');if(!t)return;
    var r=t.getBoundingClientRect(),span=r.height-window.innerHeight;
    var p=span>0?Math.min(1,Math.max(0,-r.top/span)):0;
    var steps=s.querySelectorAll('.k-depth__step');var n=Math.max(1,steps.length);
    var i=Math.min(n-1,Math.floor(p*n*0.999));
    var vis=Math.min(3,Math.floor(i*4/n));
    if(s.getAttribute('data-cur')!==String(i)){
      s.setAttribute('data-cur',i);s.setAttribute('data-step',vis);
      steps.forEach(function(el,k){el.classList.toggle('is-on',k===i)});
      s.querySelectorAll('.k-depth__dots i').forEach(function(el,k){el.classList.toggle('is-on',k===i)});
    }
  })}
  var tk=false;window.addEventListener('scroll',function(){if(!tk){tk=true;requestAnimationFrame(function(){upd();tk=false})}},{passive:true});
  window.addEventListener('resize',upd);upd();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kilde-quiz"] && !Shopify.designMode) return;
  try {
    
(function(){
  var G={
    joints:{k:'Joint & mobility plan',t:'Easier mornings',w:'Body wrap over the hips and lower back. Joint wrap on the elbow or knee they favor, then move it to the other side next session.',z:['hips','spine','elbows','knees'],n:'Easier get-ups, more willingness on stairs and walks.'},
    recovery:{k:'Recovery plan',t:'Comfort while they heal',w:'Only on the area your vet has cleared: body wrap for hips and back, joint wrap for the elbow or knee.',z:['hips','spine','knees'],n:'Calmer, more comfortable evenings during recovery.'},
    skin:{k:'Skin & wound plan',t:'Light on the spot',w:'Part the fur and place the joint wrap right on the patch. Body wrap for larger areas on the back or flank.',z:['flank','spine'],n:'Less fussing and licking at the spot.'},
    itch:{k:'Itch & allergy plan',t:'Calmer evenings',w:'Joint wrap around the lower leg or paw they lick most, body wrap along the flank and belly line.',z:['paws','flank'],n:'Less licking and chewing at night.'}
  };
  var S={joints:{puppy:'10 minutes, 2 to 3 times a week',adult:'10 minutes, 3 to 4 times a week',senior:'10 minutes, 4 to 5 evenings a week'},recovery:{puppy:'10 minutes, 3 times a week once your vet clears it',adult:'10 minutes, 3 to 5 times a week once your vet clears it',senior:'10 minutes, 3 to 5 times a week once your vet clears it'},skin:{puppy:'10 minutes daily until it settles, then 3 times a week',adult:'10 minutes daily until it settles, then 3 times a week',senior:'10 minutes daily until it settles, then 3 times a week'},itch:{puppy:'10 minutes in the evening, when licking is worst',adult:'10 minutes in the evening, when licking is worst',senior:'10 minutes in the evening, when licking is worst'}};
  var AGE={puppy:'puppy',adult:'adult dog',senior:'senior dog'};
  document.querySelectorAll('[data-k-quiz]').forEach(function(root){
    var a={},qs=root.querySelectorAll('.k-quiz__q'),bar=root.querySelector('[data-k-qbar]');
    function show(i){qs.forEach(function(q){q.classList.toggle('is-on',q.getAttribute('data-q')===String(i))});if(bar)bar.style.width=((i+1)*25)+'%'}
    function set(k,v){root.querySelectorAll('[data-k-r='+k+']').forEach(function(el){el.textContent=v})}
    function result(){
      var g=G[a.goal]||G.joints,age=a.age||'adult';
      set('kicker',g.k);set('title',g.t+' for your '+AGE[age]);set('wraps',g.w);set('sessions',(S[a.goal]||S.joints)[age]);set('notice',g.n);
      var note=root.querySelector('[data-k-r=note]');
      if(age==='puppy'){note.hidden=false;note.textContent='Puppies are still growing. Keep wraps off joints and growth plates, and check with your vet before starting.'}else{note.hidden=true}
      set('rec',a.dogs==='2'?(root.getAttribute('data-rec2')||''):(root.getAttribute('data-rec1')||''));
      root.querySelectorAll('.k-zones circle').forEach(function(c){c.classList.toggle('is-on',g.z.indexOf(c.getAttribute('data-z'))>-1)});
      show(3);
    }
    root.querySelectorAll('[data-k-a]').forEach(function(b){b.addEventListener('click',function(){
      var k=b.getAttribute('data-k-a');a[k]=b.getAttribute('data-v');
      if(k==='goal')show(1);else if(k==='age')show(2);else result();
    })});
    var rs=root.querySelector('[data-k-restart]');if(rs)rs.addEventListener('click',function(){a={};show(0)});
    var cta=root.querySelector('[data-k-quiz-cta]');
    if(cta)cta.addEventListener('click',function(){
      var pdp=document.querySelector('[data-k-pdp]');if(!pdp)return;
      var b=pdp.querySelector('input[name=k-tier][data-level="1"]');
      if(b){b.checked=true;b.dispatchEvent(new Event('change',{bubbles:true}))}
      var up=pdp.querySelector('[data-k-upgrade]');
      if(up){up.checked=(a.dogs==='2');up.dispatchEvent(new Event('change',{bubbles:true}))}
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kilde-stats"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els=document.querySelectorAll('[data-k-reveal]');if(!els.length)return;
  if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{threshold:.25});
  els.forEach(function(e){io.observe(e)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kilde-timeline"] && !Shopify.designMode) return;
  try {
    
(function(){
  var ws=document.querySelectorAll('[data-k-tl]');if(!ws.length)return;
  var mq=window.matchMedia('(max-width:749px)');
  function upd(){
    var vh=window.innerHeight;
    Array.prototype.forEach.call(ws,function(w){
      var r=w.getBoundingClientRect();
      var p=(vh*0.8-r.top)/Math.max(r.height,vh*0.45);
      p=Math.max(0,Math.min(1,p));w.style.setProperty('--p',p.toFixed(3));
      var steps=w.querySelectorAll('.k-tl__step'),n=steps.length;
      Array.prototype.forEach.call(steps,function(s,i){s.classList.toggle('is-hit',p>=(n>1?i/(n-1):1)-0.02)});
    });
  }
  var raf=null;function on(){if(raf)return;raf=requestAnimationFrame(function(){raf=null;upd()})}
  window.addEventListener('scroll',on,{passive:true});window.addEventListener('resize',on);upd();
})();

  } catch(e) { console.error(e); }
})();
})();
